<template>
    <div class="page">
        <p>
            {{ userStore.user.firstname }} {{ userStore.user.lastname }}
            <br />
            {{ userStore.user.address }}
            <br />
            {{ userStore.user.city }}, {{ userStore.user.state }} {{ userStore.user.zipcode }}
        </p>
        <p>
            {{ date }}
        </p>
        <p>
            {{ creditBureau.address_name }}
            <br />
            {{ address.street }}
            <br />
            {{ address.city }}, {{ address.state_abbreviation }} {{ address.zipcode }}
        </p>
        <p class="letter-content" style="text-align: center;">
            Notice to Agent is Notice to Principal, Notice to Principal is Notice to Agent
        </p>
        <p>
            {{ creditBureau.address_name }} you replied that the alleged transaction that you identified as late is validated. You have no proof that this alleged transaction was late. 
        </p>
        <p>
            15 U.S. Code § 1666b - Timing of payments
        </p>
        <p class="letter-content">
            (a)Time to make payments
        </p>
        <p class="letter-content">
            A creditor may not treat a payment on a credit card account under an open end consumer credit plan as late for any purpose, unless the creditor has adopted reasonable procedures designed to ensure that each periodic statement including the information required by section 1637(b) of this title is mailed or delivered to the consumer not later than 21 days before the payment due date.
        </p>
        <p class="letter-content">
            In order for any creditor to treat a payment as late you must prove that:
        </p>
        <p class="letter-content">
            1)The information required under 15 USC 1637(b) of this title was mailed out or delivered 21 Days before the payment due date please provide the proof that this information was mailed out or delivered 21 days before the statement date.
        </p>
        <p class="letter-content">
            20 15 USC 1637(b) is very specific on all required information needed or that must be mailed or delivered to the consumer! You have 10 days to send me all the required information.
        </p>
        <p class="letter-content">
            {{ creditBureau.address_name }} your reply to my dispute is Verified, have you verified what the requirements are for a creditor to treat a payment as late? The fact that you verified the information means that you are in possession of the information that was sent or mailed 21 Days before the statement date, and you are in possession of a copy of all information from 15 USC 1637(b) and the Certified mail tracking number that proved the delivery of said information for you to verify this item as late! I am requesting a copy of the information pursuant 15 USC 1637(b) and the tracking number that was used to prove delivery of said information to me the consumer 21 days before my statement date regarding this account.
        </p>
        <p class="letter-content">
            15 U.S. Code § 1681i - Procedure in case of disputed accuracy
        </p>
        <p class="letter-content">
            (5)Treatment of Inaccurate or Unverifiable Information
        </p>
        <p class="letter-content">
            (A) In general if, after any reinvestigation under paragraph (1) of any information disputed by a consumer, an item of the information is found to be inaccurate or incomplete or cannot be verified, the consumer reporting agency shall—
        </p>
        <p class="letter-content">
            (i) promptly delete that item of information from the file of the consumer, or modify that item of information, as appropriate, based on the results of the reinvestigation; and
        </p>
        <p class="letter-content">
            (ii) promptly notify the furnisher of that information that the information has been modified or deleted from the file of the consumer.
        </p>
        <p>
            Enclosed are copies of ID and proof of mailing address.
        </p>
        <p style="page-break-after: always;">
            Sincerely, <br />
            {{ userStore.user.firstname }} {{ userStore.user.lastname }}<br />
        </p>
    </div>
    <div class="page-content">
        <h1 style="padding: 0rem; 3rem; text-align: center;">Enclosures</h1>
        <p style="padding-top:3rem; text-align: center;">
            <img v-if='userStore.user.ssn_image_url' v-bind:src='userStore.user.ssn_image_url' width='300' height='200' />
            <img v-if='userStore.user.identity_image_url' v-bind:src='userStore.user.identity_image_url' width='300' height='200' />
        </p>
        <p v-if='userStore.user.address_verify_image_url'>
            <img v-bind:src='userStore.user.address_verify_image_url' width='300' height='200' />
        </p>
    </div>
</template>
<script>
    import { ref, reactive, computed } from 'vue'
    import { useReportStore } from '../../stores/ReportStore.js'
    import { useUserStore } from '../../stores/UserStore.js'
    import moment from 'moment';
    export default {
        props: {
            creditBureau: {
                type: [Array, Object]
            }
        },
        setup(props) {
            const address = _.find(props.creditBureau.addresses, { 'id': props.creditBureau.selected_address });
            return {
                date: ref(moment().format('LL')),
                reportStore: useReportStore(),
                userStore: useUserStore(),
                _: _,
                address,
            };
        }
    };
</script>
